import { useEffect } from 'react';

const SnapchatRedirect = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const error = urlParams.get("error");
    const errorDescription = urlParams.get("error_description");

    if (code) {
      localStorage.setItem("snapchat_code", code);
      window.opener?.postMessage({ type: "snapchat_code", code }, "*");
    } else if (error) {
      localStorage.setItem("snapchat_error", errorDescription || error);
      window.opener?.postMessage({ type: "snapchat_code", code: null }, "*");
    }

    window.close();
  }, []);

  return null;
};

export default SnapchatRedirect;